import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/material components
import { makeStyles } from "@mui/styles";

// core components
import styles from "../../../assets/jss/material-kit-react/components/parallaxStyle";

const useStyles = makeStyles(styles);

export default function Parallax(props: any) {
  const { filter, className, children, style, image, small } = props;
  const classes = useStyles();
  const parallaxClasses = classNames({
    [classes.parallax]: true,
    [classes.filter]: filter,
    [className]: className !== undefined,
  });
  return (
    <div
      className={parallaxClasses}
      style={{
        ...style,
        backgroundImage: "url(" + image + ")",
      }}
    >
      {children}
    </div>
  );
}
